"use client";

import Image from "next/image";
import { CONSULTATION_URL, WA_NUMBERS } from "@/lib/consultation-links";
import { openWhatsAppWithUtm } from "@/lib/whatsapp";

const featureBadges = [
  {
    text: "Insider‑backed Hong Kong setup",
  },
  {
    text: "Verified HK PayPal – world's most stable",
  },
  {
    text: "Proven structure trusted by 7 figures businesses",
  },
];
const paymentLogos = [
  { alt: "Paypal", src: "/hongkong-setup-v2/paypal.svg", imgClass: "w-[60px] h-[48px] sm:w-[80px] sm:h-[64px] md:w-[100px] md:h-[78px] xl:w-[113px] xl:h-[88px]" },
  { alt: "Payooner", src: "/hongkong-setup-v2/payooner.svg", imgClass: "w-[60px] h-[48px] sm:w-[80px] sm:h-[64px] md:w-[100px] md:h-[78px] xl:w-[113px] xl:h-[88px]" },
  { alt: "Airwallex", src: "/hongkong-setup-v2/airwallex.svg", imgClass: "w-[60px] h-[48px] sm:w-[80px] sm:h-[64px] md:w-[100px] md:h-[78px] xl:w-[113px] xl:h-[88px]" },
  { alt: "Image", src: "/hongkong-setup-v2/occean.svg", imgClass: "w-[65px] h-[52px] sm:w-[85px] sm:h-[68px] md:w-[108px] md:h-[84px] xl:w-[122px] xl:h-[94px]" },
];
const featureBadgesRow1 = [
  { icon: "/hongkong-setup-v2/group.svg", text: "Processor frozen your funds? We fix it." },
  { icon: "/hongkong-setup-v2/group.svg", text: "Verified HK PayPal — world's most stable" },
];

const featureBadgesRow2 = [
  { icon: "/hongkong-setup-v2/group.svg", text: "Global payments, simplified" },
  // { icon: "/hongkong-setup-v2/group.svg", text: "Nominee Director included" },
];
export const HeroBannerSection = () => {
  // useEffect(() => {
  //   const animate = (el: HTMLElement | null) => {
  //     if (!el) return;

  //     gsap.fromTo(
  //       el,
  //       { opacity: 0, scale: 0.95, y: 20 },
  //       {
  //         opacity: 1,
  //         scale: 1,
  //         y: 0,
  //         duration: 1.5,
  //         ease: "power3.out",
  //         delay: 0.3,
  //       }
  //     );

  //     gsap.to(el, {
  //       y: -10,
  //       repeat: -1,
  //       yoyo: true,
  //       ease: "sine.inOut",
  //       duration: 3,
  //     });
  //   };

  //   animate(illustrationRef.current);
  //   animate(mobileIllustrationRef.current);
  // }, []);
  return (
    <section className="position-relative pt-10 overflow-hidden">
      {/* <div className="h-[369px]"></div> */}
      <Image
        src="/hongkong-setup-v2/banner-gradient.svg"
        alt="Light background"
        fill
        priority
        fetchPriority="high"
        sizes="100vw"
        className="absolute max-[450px]:hidden block bottom-0 object-cover object-bottom pointer-events-none select-none"
      />

      <div className="min-[540px]:hidden block absolute bottom-0 left-1/2 -translate-x-1/2 w-[157px] h-[335px] bg-[linear-gradient(0deg,rgba(21,93,252,0.7)_10%,rgba(51,92,255,0.8)_55%,rgba(255,255,255,0.2)_100%)] blur-[40px]"></div>

      <div className="min-[540px]:hidden block absolute left-0 w-[34.775px] h-[577.697px] bg-[linear-gradient(10deg,rgba(21,93,252,0.6)_20%,rgba(0,78,255,0.5)_60%,rgba(255,255,255,0.2)_100%)] blur-[40px]"></div>

      <div className="absolute min-[540px]:hidden block right-0 w-[25.976px] h-[431.518px] rotate-[-8.041deg] bg-[linear-gradient(10deg,rgba(21,93,252,0.6)_20%,rgba(0,78,255,0.5)_60%,rgba(255,255,255,0.2)_100%)] blur-[40px]"></div>
      <div className="relative flex flex-col items-center w-full gap-4 sm:gap-5 md:gap-[32px] sm:pb-0 pb-16">
        <div className="flex flex-col items-start w-full gap-3 sm:gap-4 md:gap-[16px] sm:px-0 px-4 ">
          <div className="flex flex-col gap-4 items-center justify-center w-full mb-2">
            <div className="inline-flex items-center flex-wrap justify-center gap-0">
          {paymentLogos.map((logo, index) => {
            const rotations = [35, -53, 35, -35];
            const rot = rotations[index];
            return (
              <div
                key={index}
                className="relative w-[70px] h-[60px] sm:w-[95px] sm:h-[80px] md:w-[110px] md:h-[90px] xl:w-[124px] xl:h-[100px] flex items-center justify-center"
                style={{
                  animation: `logoRock${index} 2.5s ease-in-out infinite`,
                }}
              >
                <img
                  className={`${logo.imgClass} object-contain`}
                  alt={logo.alt}
                  src={logo.src}
                />
              </div>
            );
          })}
        </div>
        <div className="inline-flex items-center gap-1.5 sm:gap-2 pl-1.5 sm:pl-2 pr-2.5 sm:pr-4 py-0.5 sm:py-1 bg-[#f1f1f11a] rounded-[555px]">
                <img
                  className="w-[18px] h-[18px] sm:w-[22px] sm:h-[22px] xl:w-[26px] xl:h-[26px]"
                  alt="MuteTaxes"
                  src="/logo.svg"
                />
                <span className="font-inter font-medium text-[#6fa6ff] text-[10px] sm:text-xs xl:text-sm text-center tracking-[-0.28px] leading-[24px] sm:leading-[28px] xl:leading-[33px] whitespace-nowrap">
                  2,500+
                </span>
                <span className="w-px h-3 sm:h-4 bg-white/25" aria-hidden="true" />
                <span className="font-inter font-medium text-[#ffffff] text-[10px] sm:text-xs xl:text-sm text-center tracking-[0] leading-[24px] sm:leading-[28px] xl:leading-[33px] whitespace-nowrap">
                  stores processing millions monthly through our HK setups
                </span>
              </div>
          </div>
          <div className="flex flex-col items-start w-full gap-2 sm:gap-3">
             
            <h1 className="w-full [font-family:'SharpGroteskPeTrialSmBold-15',sans-serif] font-[700] text-[32px] sm:text-[38px] md:text-[46px] lg:text-[54px] xl:text-[60px] text-center leading-[110%] text-transparent"
           >
              <span className="bg-[linear-gradient(to_right,rgba(111,166,255,1)_0%,rgba(255,255,255,1)_60%)] bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] leading-[110%]">
                Process Millions.
                <br />
              </span>
              <span className="bg-[linear-gradient(to_bottom_right,rgba(208,50,50,1)_0%,rgba(255,255,255,1)_40%)] bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] leading-[120%]">
                Zero Freezes.{" "}
              </span>
              <span className="bg-[linear-gradient(to_bottom_right,rgba(111,166,255,1)_0%,rgba(255,255,255,1)_40%)] bg-clip-text [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] leading-[110%]">
                Zero Surprises.
              </span>
            </h1>
          </div>
          <div className="max-w-[800px] mx-auto text-center px-2 sm:px-4">
            <p className="text-[#a0a4b3] text-[14px] sm:text-sm md:text-base lg:text-lg xl:text-[20px] font-light ">
              <span className="text-white">Hong Kong's</span> most trusted payment infrastructure — insider-backed, compliance-ready, and built for merchants who can't afford downtime.

            </p>
            {/* <p className="text-[rgba(51,92,255,1)] text-[13px] sm:text-sm md:text-base lg:text-lg xl:text-xl font-light mt-1">
                Thanks to our insiders, access Hong Kong PSP recognized for
                unmatched stability
              </p> */}
          </div>

          {/* <div className="flex flex-col items-center w-full gap-1.5 sm:gap-2">
              <div className="flex flex-col sm:flex-row items-center justify-center w-full gap-1.5 sm:gap-2 md:gap-3">
                {featureBadges.slice(0, 2).map((badge, index) => (
                  <Badge
                    key={index}
                    className=" sm:w-auto h-auto w-auto sm:h-9 bg-[#29292a] inline-flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3 py-1.5 rounded-xl backdrop-blur-[2px] backdrop-brightness-[100%] [-webkit-backdrop-filter:blur(2px)_brightness(100%)] border-0 "
                  >
                    <span className="font-inter font-normal text-green-400 text-xs sm:text-sm text-center tracking-[0] leading-4 sm:leading-5 flex-shrink-0">
                      ✓
                    </span>
                    <span className="opacity-90 font-inter font-normal text-zinc-50 text-[10px] sm:text-xs md:text-sm text-center tracking-[0] leading-4 sm:leading-5">
                      {badge.text}
                    </span>
                  </Badge>
                ))}
              </div>

              <Badge className="w-auto sm:w-auto h-auto sm:h-9 bg-[#29292a] inline-flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3 py-1.5 rounded-xl backdrop-blur-[2px] backdrop-brightness-[100%] [-webkit-backdrop-filter:blur(2px)_brightness(100%)] border-0 ">
                <span className="font-inter font-normal text-green-400 text-xs sm:text-sm text-center tracking-[0] leading-4 sm:leading-5 flex-shrink-0">
                  ✓
                </span>
                <span className="font-inter font-normal text-zinc-50 text-[10px] sm:text-xs md:text-sm text-center tracking-[0] leading-4 sm:leading-5">
                  {featureBadges[2].text}
                </span>
              </Badge>
            </div> */}
        </div>

        <div className="flex flex-col w-full max-w-[594px] items-center justify-center px-2 sm:px-0 gap-1.5 sm:gap-2">
          {/* Row 1 */}
          <div className="flex items-center justify-center gap-1.5 sm:gap-2 w-full flex-wrap">
            {featureBadgesRow1.map((badge, index) => (
              <div
                key={index}
                className="inline-flex items-center gap-1 sm:gap-2 px-1.5 py-1 sm:p-2 rounded-[50px] border border-solid border-[#ffffff33]"
              >
                <img className="w-3 h-3 sm:w-4 sm:h-4" alt="Group" src={badge.icon} />
                <span className="font-inter font-medium text-[#ffffff] text-[10px] sm:text-xs xl:text-sm tracking-[0] leading-[13px] sm:leading-[15.4px] whitespace-nowrap">
                  {badge.text}
                </span>
              </div>
            ))}
          </div>
          {/* Row 2 */}
          <div className="inline-flex items-center gap-1.5 sm:gap-2 flex-wrap justify-center">
            {featureBadgesRow2.map((badge, index) => (
              <div
                key={index}
                className="inline-flex items-center gap-1 sm:gap-2 px-1.5 py-1 sm:p-2 rounded-[50px] border border-solid border-[#ffffff33]"
              >
                <img className="w-3 h-3 sm:w-4 sm:h-4" alt="Group" src={badge.icon} />
                <span className="font-inter font-medium text-[#ffffff] text-[10px] sm:text-xs xl:text-sm tracking-[0] leading-[13px] sm:leading-[15.4px] whitespace-nowrap">
                  {badge.text}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col items-start w-full gap-3 sm:gap-4">
          <div
            id="hero-cta-buttons"
            className="flex w-auto flex-row items-center justify-center mx-auto lg:w-full gap-2 sm:gap-3"
          >
            {/* Gradient border wrapper - primary button */}
            <div className="p-[1px] rounded-xl bg-[linear-gradient(to_bottom_right,rgba(255,255,255,1)_0%,rgba(255,255,255,0.25)_15%,rgba(255,255,255,0.25)_90%,rgba(255,255,255,1)_100%)] transition-all duration-300 ease-out hover:scale-[1.03] hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(51,92,255,0.45)] active:scale-[0.98]">
              <button
                type="button"
                onClick={() => openWhatsAppWithUtm(WA_NUMBERS, "hk-setup")}
                className="
      cursor-pointer
      relative
      w-auto h-auto
      inline-flex items-center justify-center gap-2
      px-3 py-1.5 sm:px-6 sm:py-2
      rounded-xl
      bg-[#335cff]
      text-white
      font-bold
      overflow-hidden
      hover:bg-gradient-to-r hover:from-[#476cff] hover:to-[#004eff]
    "
              >
                <div className="w-[326px] h-[80px] absolute left-[-182.5px] bottom-[-76px] rounded-[326px] bg-[#D9D9D9] blur-[27px]"></div>
                <span className="absolute inset-0 overflow-hidden">
                  <span className="absolute -left-full top-0 h-full w-full bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 transition-all duration-700 hover:opacity-100 hover:left-full" />
                </span>
                <span className="uppercase relative font-normal text-[10px] sm:text-sm tracking-[-0.32px] leading-5 sm:leading-6">
                  CHAT WITH A SPECIALIST{" "}
                </span>
              </button>
            </div>

            {/* Gradient border wrapper - dark button */}
            <div className="p-[1px] rounded-xl bg-[linear-gradient(to_bottom_right,rgba(255,255,255,0.6)_0%,rgba(255,255,255,0.1)_15%,rgba(255,255,255,0.1)_85%,rgba(255,255,255,0.6)_100%)] transition-all duration-300 ease-out hover:scale-[1.03] hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(0,0,0,0.65)] active:scale-[0.98]">
              <a
                href={CONSULTATION_URL}
                className="
      relative
      w-auto h-auto
      inline-flex items-center justify-center gap-2
      px-3 py-1.5 sm:px-6 sm:py-2
      rounded-xl
      bg-[#212121]
      text-white
      font-bold
      overflow-hidden
      hover:bg-gradient-to-r hover:from-[#2a2a2a] hover:to-[#121212]
    "
              >
                <div className="absolute w-[326px] h-[80px] left-[-182.5px] bottom-[-76px] rounded-[326px] bg-[#D9D9D9] blur-[27px]"></div>
                <span className="absolute inset-0 overflow-hidden">
                  <span className="absolute -left-full top-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 transition-all duration-700 hover:opacity-100 hover:left-full" />
                </span>
                <span className="relative text-[10px] font-normal sm:text-sm tracking-[-0.32px] leading-5 sm:leading-6">
                  BOOK A FREE CONSULTATION!
                </span>
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center w-full px-2">
            <p className="font-inter font-normal text-zinc-400 text-[10px] sm:text-xs text-center tracking-[0] leading-4">
              🔒 Secure Setup&nbsp;&nbsp;•&nbsp;&nbsp; 💳&nbsp;&nbsp;Card or
              Bank Transfer&nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp; ⚡ 7-Day
              Delivery
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

